import React, { useState, useEffect } from "react";

import SearchBar from "./searchbar";

const Header = (props) => {
    const [showSearch, setShowSearch] = useState();

    useEffect(() => {
        setShowSearch(props.showSearch);
    }, [props.showSearch]);

    return (
        <header>
            {showSearch ? (
                <div className="mb-2 flex w-full items-center justify-center md:justify-end">
                    <SearchBar
                        className="searchbar fadeIn"
                        loading={props.loading}
                        setLoading={props.setLoading}
                        selected={props.selected}
                        setSelected={props.setSelected}
                        customerList={props.customerList}
                    />
                </div>
            ) : null}
        </header>
    );
};

export default Header;
